import script from "./sf-table-row.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20BaseTableRow"
export * from "./sf-table-row.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20BaseTableRow"

const __exports__ = script;

export default __exports__